/* eslint-disable react/require-default-props */
import React, { useState, useRef, useCallback } from 'react';
import './RelatedItems.scss';
import { Button, Popup } from '@ui';
function RelatedItems({ items, additionalActions }) {
    return (React.createElement("div", { className: "relatedItemsContainer" },
        items.map((item) => (React.createElement(RelatedItem, { key: item.label, label: item.label, labelClass: item.labelClass, items: item.items }))), additionalActions === null || additionalActions === void 0 ? void 0 :
        additionalActions.map((action, index) => (React.createElement(React.Fragment, { key: index }, action)))));
}
function RelatedItem({ label, labelClass, items }) {
    const [visible, setVisible] = useState(false);
    const anchor = useRef(null);
    if (items.length === 1) {
        return (React.createElement("a", { href: items[0].path, target: "_blank", rel: "noopener noreferrer" },
            React.createElement(Button, { variant: "secondary" },
                React.createElement("i", { className: labelClass }),
                " ",
                items[0].display)));
    }
    const getItemKey = useCallback((item, index) => `${item.display.replace(' #', '').toLowerCase()}-${item.path}-${index}`, []);
    return (React.createElement("div", { className: "content-actions__option--multi content-actions__refs", id: `content_action_${label}` },
        React.createElement(Button, { isMenu: true, onClick: () => setVisible((currentVisible) => !currentVisible), ref: anchor }, `${items.length} ${label}`),
        React.createElement(Popup, { anchor: anchor.current, show: visible, onClose: () => setVisible(false), position: "bottom-left" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, { padded: true, className: "content-actions__refs" }, items.map((item, index) => (React.createElement("a", { key: getItemKey(item, index), href: item.path, target: "_blank", rel: "noopener noreferrer", className: "qmb-ui-button" },
                    React.createElement("i", { className: labelClass }),
                    " ",
                    item.display))))))));
}
export default RelatedItems;
